export { default } from './components/Trend';



// WEBPACK FOOTER //
// ./src/index.js